import React from 'react'
import PopupBg from './PopupBg'
import '../assets/css/modal.css'

const Modal = ({ title, description, onClose }) => {
  return (
    <PopupBg closeModal={onClose} opacity="transparent">
        <div className="modal">
            <h2>{title}</h2>
            <p>{description}</p>

            <div className="buttons">
                <button onClick={onClose}>
                    OK
                </button>
            </div>
        </div>
    </PopupBg>
  )
}

export default Modal